import type { Tokens } from '../../../../theming/types'

export default (config: { tokens: Tokens }) => {
  const { tokens } = config
  return {
    default: {
      asterisk: {
        fontWeight: 600,
        paddingInlineStart: tokens.spacingGap50,
      },
    },
  } as const
}
